import React from "react";
import FigmaIcon from "./FigmaIcon";

// Compatibility for controls that previously used Material glyphs.
function control(name, testId) {
  return function FigmaControlIcon({ fontSize, sx, color, ...props }) {
    const styledSize = sx && !Array.isArray(sx) && typeof sx.fontSize === "number" ? sx.fontSize : undefined;
    const size = styledSize || ({ small: 20, medium: 24, large: 35 }[fontSize]);
    return <FigmaIcon name={name} size={size} sx={sx}
      color={!color || color === "inherit" ? "currentColor" : ({ primary: "primary.main", secondary: "secondary.main", action: "action.active", disabled: "action.disabled", error: "error.main" }[color] || color)}
      data-testid={`${testId}Icon`} {...props} />;
  };
}
export const BoltOutlined = control("agent", "BoltOutlined");
export const IosShareOutlined = control("share", "IosShareOutlined");
export const DeleteOutline = control("trash", "DeleteOutline");
export const DeleteOutlineRounded = control("trash", "DeleteOutlineRounded");
export const EditOutlined = control("edit", "EditOutlined");
export const Search = control("search", "Search");
export const SearchRounded = control("search", "SearchRounded");
export const SearchOutlined = control("search", "SearchOutlined");
export const Language = control("global", "Language");
export const LanguageOutlined = control("global", "LanguageOutlined");
export const EmailOutlined = control("sms", "EmailOutlined");
export const MailOutline = control("sms", "MailOutline");
export const Link = control("link", "Link");
export const LinkOutlined = control("link", "LinkOutlined");
export const VisibilityOutlined = control("eye", "VisibilityOutlined");
export const FilterAltOutlined = control("filter", "FilterAltOutlined");
export const FilterList = control("filter", "FilterList");
export const FilterListRounded = control("filter", "FilterListRounded");
